import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ViewStyle, ImageBackground } from 'react-native';
import { useSafeAreaInsetTop } from '@/hooks/useSafeAreaInsetTop';
import iconBack from '@/assets/icon/icon_back.png';
import { useWebviewType } from '@/hooks/useWebviewType';
import { isAndroid } from '@kibt/krn-utils';
import sellerBanner from '@/assets/images/seller-banner.png';
import { useShowSellTheme } from '@/hooks/useShowSellTheme';
import { backOrClose } from '@/common/bridge/backOrClose';
import { RootSiblingParent } from 'react-native-root-siblings';
import Image from '@kds/image';

const styles = StyleSheet.create({
    box: {
        position: 'absolute',
        top: 0,
        width: '100%',
        height: 44,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // backgroundColor: '#fff',
        zIndex: 1,
    },
    left: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginLeft: 19,
        width: 80,
    },
    leftIcon: {
        width: 40,
        height: 40,
    },
    title: {
        fontWeight: 'bold',
        fontSize: 18,
        color: 'rgba(0, 0, 0, 0.88)',
    },
    right: {
        marginRight: 19,
        width: 80,
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
});

/**
 * 导航栏
 */
export default function NavBar(props: {
    showSellTheme?: boolean;
    customLeft?: React.ReactNode;
    left?: any;
    leftStyle?: ViewStyle;
    title?: React.ReactNode;
    customTitle?: React.ReactNode;
    titleStyle?: ViewStyle;
    customRight?: React.ReactNode;
    right?: React.ReactNode;
    rightStyle?: ViewStyle;
    onLeftClick?: any;
    onRightClick?: any;
    safeAreaInsetTop?: boolean;
    placeholder?: boolean;
    placeholderStyle?: ViewStyle;
    navBarRef?: React.RefObject<View>;
    style?: ViewStyle;
    outerWebviewType?: 'fullScreen' | 'halfScreen';
    isFromDetail?: boolean;
}) {
    const {
        showSellTheme = false,
        safeAreaInsetTop = true,
        right = '',
        placeholder = true,
        placeholderStyle: placeholderStyleOuter,
        onRightClick = () => console.log('onRightClick'),
        style = {},
        outerWebviewType,
        isFromDetail = false,
    } = props;

    const innerWebviewType = useWebviewType();
    const webviewType = outerWebviewType ?? innerWebviewType;
    const insetTop = useSafeAreaInsetTop();
    const { showSellBanner: showSellBannerByAPI } = useShowSellTheme();
    const showSellBanner = showSellTheme && showSellBannerByAPI;

    const backgroundColorStyle = StyleSheet.create({
        mgb: {
            // paddingBottom: 8,
        },
        bg: {
            backgroundColor: '#fff',
        },
    });

    const insetStyle = StyleSheet.create({
        insetTop: {
            paddingTop: safeAreaInsetTop && webviewType === 'fullScreen' ? insetTop : 0,
            height: 44 + (safeAreaInsetTop && webviewType === 'fullScreen' ? insetTop : 0),
        },
    });
    const placeholderStyle = StyleSheet.create({
        holder: {
            height: webviewType === 'halfScreen' ? 44 : insetTop + 44,
        },
    });

    const defaultLeft = <Image className="m-navbar-left-icon-back" style={styles.leftIcon} source={iconBack} />;
    const onDefaultLeftClick = () => {
        backOrClose();
    };

    const renderNavBar = () => {
        return (
            <View
                ref={props.navBarRef}
                style={[styles.box, insetStyle.insetTop, showSellBanner ? backgroundColorStyle.mgb : backgroundColorStyle.bg, style]}
                className="m-navbar-header"
            >
                <TouchableOpacity activeOpacity={0.6} onPress={props.onLeftClick || onDefaultLeftClick}>
                    {props.customLeft ?? (
                        <View style={[styles.left, props.leftStyle]} className="m-navbar-left-icon">
                            {typeof props.left === 'string' ? <Text>{props.left}</Text> : props.left || defaultLeft}
                        </View>
                    )}
                </TouchableOpacity>
                {props.customTitle ?? (
                    <View style={props.titleStyle}>
                        <Text className="m-navbar-title" style={styles.title}>
                            {props.title}
                        </Text>
                    </View>
                )}
                {props.customRight ?? (
                    <TouchableOpacity activeOpacity={0.6} onPress={onRightClick}>
                        <View style={[styles.right, props.rightStyle]}>{typeof right === 'string' ? <Text>{right}</Text> : right}</View>
                    </TouchableOpacity>
                )}
            </View>
        );
    };

    const renderNavBarWrap = () => {
        if (showSellBanner) {
            return (
                <ImageBackground source={sellerBanner} resizeMode="cover" width={414} height={88} style={[insetStyle.insetTop]}>
                    {renderNavBar()}
                </ImageBackground>
            );
        }

        return (
            <>
                {renderNavBar()}
                {placeholder ? <View className="m-navbar-placeholder" style={[placeholderStyle.holder, placeholderStyleOuter]} /> : null}
            </>
        );
    };
    // 商详页使用Overlay时,下滑时RootSiblingParent会导致Overlay覆盖不全
    if (isFromDetail && isAndroid) {
        return <View>{renderNavBarWrap()}</View>;
    } else {
        // spa 里面 一码多投h5，会有css层级问题，导致 Popup等弹窗类的使用RootSiblingParent的有问题
        return <RootSiblingParent>{renderNavBarWrap()}</RootSiblingParent>;
    }
}
